import React from 'react';
import useNavState from './useNavState';
import AccountSwitcher from './AccountSwitcher';

import './index.scss';

// TODO: enable eslint after we refactor
/* eslint-disable */

export default function Navbar() {
  const [navOpen, openNav] = useNavState();
  const [adTypeOpen, openAdType] = useNavState();

  return (
    <nav className="navigation">
      <AccountSwitcher />
      <div className="navigation__regular-dropdown">
        <div role="button" id="navigation" className="navigation__regular" onClick={openNav}>Navigation</div>
        {
          navOpen && (
            <nav className="navigation__choose-menu navigation__choose-menu--active">
              <a href="/">Dashboard</a>
              <a href="listings.html">Manage Listings</a>
              <a href="settings.html">Settings | Help</a>
            </nav>
          )
        }
      </div>
      <div className="navigation__ads-dropdown">
        <div role="button" id="ad-type-navigation" className="navigation__choose-ad-type" onClick={openAdType}>New Ad / Post</div>
        {
          adTypeOpen && (
            <nav className="navigation__ad-types navigation__ad_types--active">
              <a href="property.html">Single Property Carousel</a>
              <a href="collage.html">Single Property Collage</a>
              <a href="search.html">Single Search</a>
              <a href="multi.html">Multiple Search</a>
              <a href="area.html">Area / Content w/ Search</a>
              <a href="single.html">Single Image Link</a>
              <a href="multi-custom.html">Multiple Image / Link</a>
              <a href="video.html">Video</a>
            </nav>
          )
        }
      </div>
    </nav>
  );
}

/* eslint-enable */
